import { render, staticRenderFns } from "./Banner_list.vue?vue&type=template&id=737853bc&scoped=true"
import script from "./Banner_list.vue?vue&type=script&lang=js"
export * from "./Banner_list.vue?vue&type=script&lang=js"
import style0 from "./Banner_list.vue?vue&type=style&index=0&id=737853bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737853bc",
  null
  
)

export default component.exports